module.exports = __webpack_public_path__ + "dashboard/img/trash.59ca6defabc17f514450a7c1dd143943.svg";